<div data-cy-modal="edituser">
    <h4 class="modal-title">
        <i class="fa fa-user-lock"></i> Create lock pin
    </h4>
    <div class="flex-fill">
        <hr>
    </div>
    <div mat-dialog-content>
        <form [formGroup]="createPinForm" (submit)="createPin()">
            <div class="form-row mb-2">
                <div class="col-12">
                    <input (keypress)="preventTextInput($event)" formControlName="pin" type="password"
                        class="form-control" [ngClass]="{
                        'is-invalid':
                        controls.pin.errors && controls.pin.touched
                        }" placeholder="Pin" data-cy-input="pin" />
                    <div *ngIf="createPinForm.invalid" class="invalid-feedback">
                        <div *ngIf="controls.pin.hasError('required') &&
                            controls.pin.touched">
                            Pin is required
                        </div>
                        <div *ngIf="controls.pin.hasError('minlength') &&
                            controls.pin.touched">
                            Pin must be {{ pinLength }} digits
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row mb-2">
                <div class="col-12">
                    <input (keyup)="preventTextInput($event)" formControlName="confirmPin" type="password"
                        class="form-control" [ngClass]="{
                        'is-invalid':
                        controls.confirmPin.errors &&
                        controls.confirmPin.touched
                        }" placeholder="Confirm Pin" data-cy-input="confirmpin" />
                    <div *ngIf="createPinForm.invalid" class="invalid-feedback">
                        <div *ngIf="controls.confirmPin.hasError('required') &&
                            controls.confirmPin.touched">
                            Confirm pin is required
                        </div>
                        <div *ngIf="controls.confirmPin.hasError('matched') &&
                            controls.confirmPin.touched">
                            Pins do not match
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row mb-4">
                <div class="form-group col-12">
                    <button class="btn btn-primary btn-block" data-cy-button="create">
                        Create
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>